export function Default() {
    return {
    
        logOutApi: {
            isProcessing: false,
            error: false,
            isDataFetched: false,
        },
    }
}